import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import DeviceLogin from 'containers/DeviceLogin'
import ReveneCenterList from 'pages/ReveneCenterList'
import Orders from 'pages/Orders'
import Login from 'pages/Login'

import { isAuth, checkTokenExpireTime } from 'utils/auth'
import { PrivateRoute } from './PrivateRouter'
import ImageVersioningContext from 'context/ImageVersioningContext'
import { getRvcUuid } from '../store/AppState/selector'

const ONE_MINUTE = 60000

export class Routes extends Component {
  tokenRefreshIntervalId = null

  static contextType = ImageVersioningContext

  componentDidMount() {
    this.setImageVersion()
    this.setTokenRefreshInterval(checkTokenExpireTime)
  }

  setTokenRefreshInterval = callback => {
    callback()
    this.tokenRefreshIntervalId = setInterval(() => callback(), ONE_MINUTE)
  }

  componentWillUnmount() {
    clearInterval(this.tokenRefreshIntervalId)
  }

  setImageVersion = () => {
    const imageVersion = new Date().getTime()
    const { setVersion } = this.context
    setVersion(imageVersion)
  }

  appropriateRedirectLink = () => {
    if (!isAuth()) return '/login'

    const { rvcUuid } = this.props
    if (rvcUuid) return `/orders/${rvcUuid}`

    return '/revenueCenters'
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <Redirect to={this.appropriateRedirectLink()} />
          </Route>
          <Route component={Login} exact path="/login" />
          <Route component={DeviceLogin} exact path="/device-login" />
          <PrivateRoute component={ReveneCenterList} exact path="/revenueCenters" />
          <PrivateRoute component={Orders} path="/orders/:id" />
        </Switch>
      </Router>
    )
  }
}

Routes.propTypes = {
  rvcUuid: PropTypes.string,
}

const mapStateToProps = state => ({
  rvcUuid: getRvcUuid(state),
})

export default connect(
  mapStateToProps,
  undefined,
)(Routes)
